"use client";

export const BlackButtons = () => {
	const className =
		"shadow bg-black text-white w-72 rounded-full text-xl p-2 font-bold ";
	return (
		<div className={"flex flex-row justify-center gap-2"}>
			<button
				type="button"
				className={className}
				onClick={(): void => {
					window.open("https://prossell.jp/contact");
				}}
			>
				<span className={"whitespace-nowrap"}>企業の方は</span>
				<span className={"whitespace-nowrap"}>こちら</span>
			</button>
			<button
				type="button"
				className={className}
				onClick={(): void => {
					window.open("https://prossell.jp/contact");
				}}
			>
				<span className={"whitespace-nowrap"}>学校の方は</span>
				<span className={"whitespace-nowrap"}>こちら</span>
			</button>
		</div>
	);
};
